export default `
  query customerOrders {
    customer {
      orders(
        pageSize: 20,
        sort: { sort_direction: ASC, sort_field: CREATED_AT }
      ) {
        items {
          status
          items {
            product_name
            selected_options {
              label
              value
            }
          }
          id
          order_date
          order_number
          total {
            grand_total {
              value
              currency
            }
          }
        }
      }
    }
  }
`
